import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";

export const StyledListItem = styled.li`
    list-style: disc;
    width: 350px;
    ${setFontVariant("caption", colorsPalettes.carbon[400])}
`;

export const StyledDownloadImg = styled.img`
    width: 100px;
    height: 100px;
`;

export const StyledDownloadHelpText = styled.div`
    margin-top: 12px;
    ${setFontVariant("body1", colorsPalettes.carbon[500])};
`;
export const StyledList = styled.ul`
    margin: 12px 0 10px 10px;
    margin-bottom: 24px;
`;

export const StyledDownloadContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    width: 622px;
    height: 459px;

    & .cancel {
        margin-top: 12px;
    }
`;

export const StyledDownloadTitle = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[500])}
`;
